export class Utils {

  static dataHoraAtual(): string {
    const date = new Date();
    date.setHours(date.getHours() - 3)
    const resp = date.toISOString().substring(0, 16)
    console.log('dtatime', resp)
    return resp
  }
}
